export default "__VITE_ASSET__c69fdb38__"